<div class="modal-container product d-flex flex-column justify-content-between h-100" (isEnglish)="isEnglish = $event">
  <div class="modal-header bg-header d-flex justify-content-center" mat-dialog-header>
    <h1 class="m-0 p-0 font-20 regular fw-bold" mat-dialog-title>
      {{ data?.labels?.header || "EXHIBITIONS_AND_EVENTS.SEND_REJECT_MESSAGE" | translate }}
    </h1>
  </div>

  <div class="px-4 py-3 m-0" mat-dialog-content>
    <form class="row justify-content-center" [formGroup]="rejectionForm">
      <div class="col-lg-8">
        <app-input-text
          [label]="data?.labels?.rejectLabel || 'EXHIBITIONS_AND_EVENTS.REJECT_MESSAGE'"
          formControlName="exception"
          inputType="textarea"
        />
      </div>
    </form>

    @if (data?.list?.length > 0) {
      <div class="reservations px-4 mb-4">
        <h5 class="font-18 fw-bold">{{ "BLOCK_DAYS.RESERVATIONS_WILL_BE_CANCELLED" | translate }}</h5>

        <div class="mt-3">
          <div class="row border thin header py-1 mb-3">
            <div class="col-5">
              <span>{{ "FIELDS.RESERVATION_TYPE" | translate }}</span>
            </div>

            <div class="col-5">
              <span>{{ "FIELDS.STATUS" | translate }}</span>
            </div>

            <div class="col-2 d-flex justify-content-end">
              <span class="mx-2">{{ "ACTIONS.VIEW" | translate }}</span>
            </div>
          </div>

          <div class="reservations-content d-flex flex-column gap-3">
            @for (item of data?.list; track $index) {
              <div class="row border thin py-1">
                <div class="col-5">
                  <span>{{ isEnglish ? item.reservationTicketType.nameEn : item.reservationTicketType.nameAr }}</span>
                </div>

                <div class="col-5">
                  <span>{{ isEnglish ? item.status.nameEn : item.status.nameAr }}</span>
                </div>

                <div class="col-2 d-flex justify-content-end">
                  <a class="mx-2" [routerLink]="'/admin/reservations/view/' + item.reservationNumber" target="_blank">
                    <span class="db-icon-eye cursor-pointer"></span>
                  </a>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>

  <div class="modal-footer w-100 d-flex justify-content-end gap-3" mat-dialog-actions>
    <app-button btnLabel="ACTIONS.CANCEL" btnClass="font-14 error" mat-dialog-close />

    <app-button
      btnClass="font-14 primary solid px-4"
      [btnLabel]="data?.labels?.rejectButton || 'EXHIBITIONS_AND_EVENTS.REJECT'"
      [disabled]="rejectionForm.invalid"
      (onClick)="onDismiss()"
    />
  </div>
</div>
